/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var COLOR_OPTION_NAMES = ['color', 'colour', 'couleur', 'colore', 'farbe', '색', '色', 'farg', 'färg', 'farve'];

  function moveQuickAddModals(root) {
    var scope = root || document;
    var modals = scope.querySelectorAll('[data-quick-add-modal]');
    var index;

    for (index = 0; index < modals.length; index += 1) {
      if (modals[index].parentNode !== document.body) {
        document.body.appendChild(modals[index]);
      }
      updateQuickAddModal(modals[index]);
    }
  }

  function getSelectedOptionsFromDOM(modal) {
    var productData = getQuickAddProductData(modal);
    var selectedButtons;
    var options = [];
    var i;
    var pos;

    if (!modal || !productData || !productData.options) {
      return null;
    }

    selectedButtons = modal.querySelectorAll('[data-quick-add-option].is-selected');

    for (i = 0; i < selectedButtons.length; i += 1) {
      pos = parseInt(selectedButtons[i].getAttribute('data-option-position'), 10) - 1;
      options[pos] = selectedButtons[i].getAttribute('data-option-value');
    }

    if (options.length === productData.options.length) {
      for (i = 0; i < options.length; i += 1) {
        if (typeof options[i] === 'undefined' || options[i] === null) {
          return null;
        }
      }
      return options;
    }

    return null;
  }

  function arraysMatch(first, second) {
    var index;

    if (!first || !second || first.length !== second.length) {
      return false;
    }

    for (index = 0; index < first.length; index += 1) {
      if (first[index] !== second[index]) {
        return false;
      }
    }

    return true;
  }

  function getQuickAddState(modal) {
    if (!modal.__quickAddState) {
      modal.__quickAddState = {
        selectedOptions: [],
        currentVariant: null,
        isLoading: false,
        errorMessage: ''
      };
    }

    return modal.__quickAddState;
  }

  function getQuickAddProductData(modal) {
    var productJson;

    if (modal.__quickAddProductData) {
      return modal.__quickAddProductData;
    }

    productJson = modal.querySelector('[data-quick-add-product-json]');

    if (!productJson) {
      return null;
    }

    try {
      modal.__quickAddProductData = JSON.parse(productJson.textContent);
    } catch (error) {
      modal.__quickAddProductData = null;
    }

    return modal.__quickAddProductData;
  }

  function findVariantById(productData, variantId) {
    var index;

    for (index = 0; index < productData.variants.length; index += 1) {
      if (productData.variants[index].id === variantId) {
        return productData.variants[index];
      }
    }

    return null;
  }

  function findMatchingVariant(productData, options) {
    var index;

    for (index = 0; index < productData.variants.length; index += 1) {
      if (arraysMatch(productData.variants[index].options, options)) {
        return productData.variants[index];
      }
    }

    return null;
  }

  function findVariantByOptionValue(productData, optionIndex, optionValue, availableOnly) {
    var index;
    var variant;

    for (index = 0; index < productData.variants.length; index += 1) {
      variant = productData.variants[index];

      if (variant.options[optionIndex] === optionValue && (!availableOnly || variant.available)) {
        return variant;
      }
    }

    return null;
  }

  function getDefaultOptions(modal, productData) {
    var state = getQuickAddState(modal);
    var defaultVariant = findVariantById(productData, productData.selected_variant_id);
    var optionButtons;
    var optionIndex;

    if (state.defaultOptions && state.defaultOptions.length) {
      return state.defaultOptions.slice(0);
    }

    if (!defaultVariant) {
      for (optionIndex = 0; optionIndex < productData.variants.length; optionIndex += 1) {
        if (productData.variants[optionIndex].available) {
          defaultVariant = productData.variants[optionIndex];
          break;
        }
      }
    }

    if (!defaultVariant && productData.variants.length) {
      defaultVariant = productData.variants[0];
    }

    if (defaultVariant && defaultVariant.options) {
      state.defaultOptions = defaultVariant.options.slice(0);
      return state.defaultOptions.slice(0);
    }

    state.defaultOptions = [];

    for (optionIndex = 0; optionIndex < productData.options.length; optionIndex += 1) {
      optionButtons = modal.querySelectorAll('[data-quick-add-option][data-option-position="' + productData.options[optionIndex].position + '"]');

      if (optionButtons.length) {
        state.defaultOptions.push(optionButtons[0].getAttribute('data-option-value'));
      }
    }

    return state.defaultOptions.slice(0);
  }

  function renderSelectedOptions(modal, selectedOptions) {
    var buttons = modal.querySelectorAll('[data-quick-add-option]');
    var index;
    var optionIndex;
    var isSelected;

    for (index = 0; index < buttons.length; index += 1) {
      optionIndex = parseInt(buttons[index].getAttribute('data-option-position'), 10) - 1;
      isSelected = selectedOptions[optionIndex] === buttons[index].getAttribute('data-option-value');

      buttons[index].classList.toggle('is-selected', isSelected);
      buttons[index].setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }
  }

  function updateInlineStatus(modal, message) {
    var statusElement = modal.querySelector('[data-quick-add-status]');

    if (statusElement) {
      statusElement.textContent = message || '';
    }
  }

  function updateQuickAddModal(modal) {
    var productData = getQuickAddProductData(modal);
    var state = getQuickAddState(modal);
    var selectedOptions;
    var currentVariant;
    var buttons;
    var buttonIndex;
    var optionIndex;
    var candidateOptions;
    var candidateVariant;
    var imageElement;
    var priceElement;
    var submitButton;
    var defaultLabel;
    var statusMessage;

    if (!productData) {
      return;
    }

    if (!state.selectedOptions.length) {
      state.selectedOptions = getSelectedOptionsFromDOM(modal) || getDefaultOptions(modal, productData);
    }

    selectedOptions = state.selectedOptions.slice(0);
    currentVariant = findMatchingVariant(productData, selectedOptions);
    state.currentVariant = currentVariant;

    renderSelectedOptions(modal, selectedOptions);

    buttons = modal.querySelectorAll('[data-quick-add-option]');

    for (buttonIndex = 0; buttonIndex < buttons.length; buttonIndex += 1) {
      optionIndex = parseInt(buttons[buttonIndex].getAttribute('data-option-position'), 10) - 1;
      candidateOptions = selectedOptions.slice(0);
      candidateOptions[optionIndex] = buttons[buttonIndex].getAttribute('data-option-value');
      candidateVariant = findMatchingVariant(productData, candidateOptions);

      buttons[buttonIndex].disabled = !candidateVariant;
      buttons[buttonIndex].classList.toggle('is-unavailable', !!candidateVariant && !candidateVariant.available);
    }

    imageElement = modal.querySelector('[data-quick-add-image]');

    if (imageElement) {
      if (currentVariant && currentVariant.image) {
        imageElement.src = currentVariant.image;
      } else if (productData.featured_image) {
        imageElement.src = productData.featured_image;
      }
    }

    priceElement = modal.querySelector('[data-quick-add-price]');

    if (priceElement) {
      if (currentVariant) {
        priceElement.textContent = currentVariant.formatted_price;
      }
    }

    submitButton = modal.querySelector('[data-quick-add-submit]');

    if (!submitButton) {
      return;
    }

    defaultLabel = submitButton.getAttribute('data-default-label') || window.languages.productFormAddToCart;

    if (state.isLoading) {
      submitButton.textContent = defaultLabel;
      submitButton.setAttribute('disabled', 'disabled');
      updateInlineStatus(modal, state.errorMessage);
      return;
    }

    if (!currentVariant) {
      submitButton.textContent = window.languages.productFormUnavailable;
      submitButton.setAttribute('disabled', 'disabled');
      statusMessage = window.languages.productFormUnavailable;
    } else if (!currentVariant.available) {
      submitButton.textContent = window.languages.productFormSoldOut;
      submitButton.setAttribute('disabled', 'disabled');
      statusMessage = '';
    } else {
      submitButton.textContent = defaultLabel;
      submitButton.removeAttribute('disabled');
      statusMessage = '';
    }

    if (currentVariant) {
      submitButton.setAttribute('data-variant-id', currentVariant.id);
    }

    if (state.errorMessage) {
      statusMessage = state.errorMessage;
    }

    updateInlineStatus(modal, statusMessage);
  }

  function findColorOptionIndex(productData) {
    var index;
    var optionName;

    for (index = 0; index < productData.options.length; index += 1) {
      optionName = String(productData.options[index].name || '').toLowerCase();

      if (COLOR_OPTION_NAMES.indexOf(optionName) !== -1) {
        return index;
      }
    }

    return -1;
  }

  function prepareQuickAddModal(trigger) {
    var modalId = trigger.getAttribute('aria-controls');
    var modal = modalId ? document.getElementById(modalId) : null;
    var productData;
    var productCard;
    var swatchInput;
    var colorOptionIndex;
    var matchedVariant;
    var state;

    if (!modal) {
      return;
    }

    moveQuickAddModals(document);

    productData = getQuickAddProductData(modal);

    if (!productData) {
      return;
    }

    state = getQuickAddState(modal);
    state.selectedOptions = getSelectedOptionsFromDOM(modal) || getDefaultOptions(modal, productData);
    state.errorMessage = '';
    state.isLoading = false;

    productCard = trigger.closest('.ProductItem');
    swatchInput = productCard ? productCard.querySelector('.ColorSwatch__Radio:checked') : null;
    colorOptionIndex = findColorOptionIndex(productData);

    if (swatchInput && colorOptionIndex !== -1) {
      matchedVariant = findVariantByOptionValue(productData, colorOptionIndex, swatchInput.value, true) || findVariantByOptionValue(productData, colorOptionIndex, swatchInput.value, false);

      if (matchedVariant) {
        state.selectedOptions = matchedVariant.options.slice(0);
      }
    }

    updateQuickAddModal(modal);
  }

  function showCardQuickAddError(trigger, message) {
    var mediaContainer = trigger.closest('.ProductItem__Media');
    var alertElement;

    if (!mediaContainer) {
      return;
    }

    alertElement = mediaContainer.querySelector('.ProductItem__QuickAddAlert');

    if (!alertElement) {
      alertElement = document.createElement('div');
      alertElement.className = 'ProductItem__QuickAddAlert';
      mediaContainer.appendChild(alertElement);
    }

    alertElement.textContent = message;
    alertElement.classList.add('is-visible');

    if (alertElement.__quickAddTimer) {
      clearTimeout(alertElement.__quickAddTimer);
    }

    alertElement.__quickAddTimer = setTimeout(function () {
      alertElement.classList.remove('is-visible');

      if (alertElement.parentNode) {
        alertElement.parentNode.removeChild(alertElement);
      }
    }, 2500);
  }

  function addToCart(payload) {
    return fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      }

      return response.json().then(function (content) {
        throw new Error(content.description || window.languages.productFormUnavailable);
      }, function () {
        throw new Error(window.languages.productFormUnavailable);
      });
    });
  }

  function cartDrawerExists() {
    return !!document.getElementById('sidebar-cart');
  }

  function dispatchProductAdded(variant, quantity) {
    if (cartDrawerExists()) {
      document.dispatchEvent(new CustomEvent('product:added', {
        detail: {
          variant: variant,
          quantity: quantity
        }
      }));
    } else {
      window.location.href = window.routes.cartUrl;
    }
  }

  function closeQuickAddModal(modal) {
    var closeButton = modal.querySelector('[data-action="close-modal"]');

    if (closeButton) {
      closeButton.click();
    }
  }

  function handleQuickAddTrigger(event, trigger) {
    var variantId;

    if (trigger.disabled || trigger.classList.contains('is-loading')) {
      return;
    }

    if (trigger.getAttribute('data-quick-add-mode') === 'modal') {
      prepareQuickAddModal(trigger);
      return;
    }

    event.preventDefault();

    variantId = parseInt(trigger.getAttribute('data-variant-id'), 10);

    if (!variantId) {
      return;
    }

    trigger.classList.add('is-loading');
    trigger.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    addToCart({
      id: variantId,
      quantity: 1
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('disabled');

      dispatchProductAdded({
        id: variantId,
        title: trigger.getAttribute('data-product-title')
      }, 1);
    }, function (error) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('disabled');
      showCardQuickAddError(trigger, error.message);
    });
  }

  function handleQuickAddOption(event, optionButton) {
    var modal = optionButton.closest('[data-quick-add-modal]');
    var state;
    var optionIndex;

    if (!modal || optionButton.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    state = getQuickAddState(modal);

    if (!state.selectedOptions.length) {
      state.selectedOptions = getSelectedOptionsFromDOM(modal) || getDefaultOptions(modal, getQuickAddProductData(modal));
    }

    optionIndex = parseInt(optionButton.getAttribute('data-option-position'), 10) - 1;
    state.selectedOptions[optionIndex] = optionButton.getAttribute('data-option-value');
    state.errorMessage = '';

    updateQuickAddModal(modal);
  }

  function handleQuickAddSubmit(event, submitButton) {
    var modal = submitButton.closest('[data-quick-add-modal]');
    var state;
    var productData;

    if (!modal) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    state = getQuickAddState(modal);
    productData = getQuickAddProductData(modal);

    if (!state.currentVariant && productData) {
      if (!state.selectedOptions || !state.selectedOptions.length) {
        state.selectedOptions = getSelectedOptionsFromDOM(modal) || getDefaultOptions(modal, productData);
      }
      updateQuickAddModal(modal);
    }

    if (!state.currentVariant && productData) {
      var fallbackVariantId = parseInt(submitButton.getAttribute('data-variant-id'), 10);
      if (fallbackVariantId) {
        state.currentVariant = findVariantById(productData, fallbackVariantId);
      }
    }

    if (state.isLoading || !state.currentVariant || !state.currentVariant.available) {
      return;
    }

    state.isLoading = true;
    state.errorMessage = '';
    updateQuickAddModal(modal);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    addToCart({
      id: state.currentVariant.id,
      quantity: 1
    }).then(function () {
      state.isLoading = false;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      updateQuickAddModal(modal);
      closeQuickAddModal(modal);
      dispatchProductAdded(state.currentVariant, 1);
    }, function (error) {
      state.isLoading = false;
      state.errorMessage = error.message;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      updateQuickAddModal(modal);
    });
  }

  // Capture phase listener ensures quick-add trigger is handled before theme.js stops propagation
  document.addEventListener('click', function (event) {
    var quickAddTrigger = event.target.closest('[data-quick-add-trigger]');

    if (quickAddTrigger) {
      handleQuickAddTrigger(event, quickAddTrigger);
    }
  }, true);

  // Bubble phase listener for modal interactions
  document.addEventListener('click', function (event) {
    var optionButton = event.target.closest('[data-quick-add-option]');
    var submitButton = event.target.closest('[data-quick-add-submit]');

    if (optionButton) {
      handleQuickAddOption(event, optionButton);
      return;
    }

    if (submitButton) {
      handleQuickAddSubmit(event, submitButton);
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      moveQuickAddModals(document);
    });
  } else {
    moveQuickAddModals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    moveQuickAddModals(event.target);
  });
})();
